// Redux Actions
import {
  SET_STATE_TOOLTIP,
  SET_TOOLTIP
} from "../types";

export function setStateTooltip(payload) {
  return { type: SET_STATE_TOOLTIP, payload }
};

export function setTooltip(payload) {
  return { type: SET_TOOLTIP, payload }
};
